// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main___miew","section":"index_section__I_1k1"};